import Vue from 'vue'
import moment from 'moment'

export default {
  state: {
    currentUser: null
  },
  getters: {
    getCurrentUser: state => state.currentUser
  },
  actions: {
    getAuthToken: (state ,payload) => {
      return Vue.axios.post('auth/login', payload).then(response => {
        if(response.status == 200 && response.data && response.data.token){
           localStorage.setItem('user-token', response.data.token)
           localStorage.setItem('expire-token', moment().add(response.data.expires_in, 'seconds').format('YYYY-MM-DD HH:mm:ss'))
           return response.data.token;
        } else {
          return null
        }
      }).catch(() => {
        localStorage.removeItem('user-token') // if the request fails, remove any possible user token if possible
        localStorage.removeItem('expire-token') // if the request fails, remove any possible user token if possible
        return null
      })
    },
    clearUserToken: () => {
      localStorage.removeItem('user-token') // if the request fails, remove any possible user token if possible
      localStorage.removeItem('expire-token') // if the request fails, remove any possible user token if possible
      return true
    }
  },
  mutations: {},
}
